import { use_hints_shortcuts_data } from '@/hooks/hints_shortcut/use_hints_shortcuts_data';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { IHintShortcutGroup } from '@shared/dto/hint_shortcuts/i_hint_shortcut_group';
import { useMemo } from 'react';

export function use_all_hints_shortcuts_columns() {
  const { hint_shortcuts_data } = use_hints_shortcuts_data(Object.values(EShortcutType));

  const out = useMemo(() => {
    const out: IHintShortcutGroup[][] = [[], [], []];

    const columns_rows = [0, 0, 0];

    hint_shortcuts_data.sort((a, b) => a.group.localeCompare(b.group));

    let groups = get_groups();

    for (const group_data of groups) {
      if (group_data.group == EShortcutGroup.GENERAL) continue;

      // Find column with the smallest current height (i.e., fill top-down)
      let column_index_with_min_rows = columns_rows.findIndex((h, i) => columns_rows[i] === Math.min(...columns_rows));

      out[column_index_with_min_rows].push(group_data);

      columns_rows[column_index_with_min_rows] += group_data.items.length;
    }

    let groupd_data_general = groups.find_or_assert(item => item.group == EShortcutGroup.GENERAL);

    let data_column_0 = out[0];
    out[0] = [groupd_data_general, ...data_column_0];

    return out;
  }, [hint_shortcuts_data]);

  function get_groups() {
    let out_map: Map<EShortcutGroup, IHintShortcutGroup> = new Map();

    for (let item of hint_shortcuts_data) {
      let items_in_group = out_map.get_value_or_default(item.group, { group: item.group, items: [] });

      items_in_group.items.push(item);

      out_map.set(item.group, items_in_group);
    }

    return Array.from(out_map.values());
  }

  return out;
}
